import { type Node } from '@xyflow/react'
import { type IFlowAction } from 'widgets/Flow'
import { getChildActionsByIdAndType } from 'pages/settings/pages/inboxes/pages/id/pages/settings/calling/smart-call-flow/ui/SmartCallFlowBuilder/utils/getChildActionsByIdAndType.ts'

const VERTICAL_GAP_WITH_LABEL = 196
const VERTICAL_GAP_WITH_CHILDREN = 213
const VERTICAL_GAP = 94
const TOP_PADDING = 24
const X_BRANCH_WIDTH = 320

export const getNodesByChangesMap = ({
  nodeChangesMap,
  getActionById,
  containerWidth,
}: {
  nodeChangesMap: Map<string, Node>
  getActionById: (id: string) => IFlowAction | undefined
  containerWidth: number
}) => {
  const triggerAction = getActionById('trigger')

  const getEndsActionCountById = (id: string) => {
    return getChildActionsByIdAndType({
      id,
      getActionById,
      type: 'callEnds',
    }).length
  }

  const newNodes: Node[] = []

  const drawNode = (action: IFlowAction, x: number, y: number) => {
    const node = nodeChangesMap.get(action.actionStore.id)

    if (!node) {
      return
    }

    const ownWidth = node.measured?.width ?? action?.actionStore.defaultWidth ?? 0
    const nodeHeight = node.measured?.height || action?.actionStore.defaultHeight || 0

    newNodes.push({
      ...node,
      position: {
        x: x - ownWidth / 2,
        y: y,
      },
    })

    const yBranchGap =
      action.actionStore.edgeType === 'customEdgeWithLabel'
        ? action.actionStore.nextIds.length > 1
          ? VERTICAL_GAP_WITH_CHILDREN
          : VERTICAL_GAP_WITH_LABEL
        : VERTICAL_GAP

    const getXWidth = (count: number) => (count ? count * X_BRANCH_WIDTH : 0)
    const xWidth = getXWidth(getEndsActionCountById?.(action.actionStore.id) || 0)

    const actionChildrenWidthList = action.actionStore.nextIds.map((id) => {
      const childEndsCount = getEndsActionCountById?.(id) || 0
      return getXWidth(childEndsCount)
    })

    action.actionStore.nextIds.forEach((id: string, index, self) => {
      const action = getActionById(id)
      if (!action) return

      const getY = () => {
        const getGapForChild = (childId: string) => {
          const child = getActionById(childId)
          return child?.actionStore.type === 'addButton' ? 38 : yBranchGap
        }

        return y + nodeHeight + getGapForChild(id)
      }
      const newY = getY()

      const getX = () => {
        if (self.length > 1) {
          const left = actionChildrenWidthList.slice(0, index).reduce((acc, x) => acc + x, 0)

          const x1 = left + actionChildrenWidthList[index] / 2
          return x1 + x - xWidth / 2
        }

        return x
      }

      const newX = getX()

      drawNode(action, newX, newY)
    })
  }
  if (triggerAction) {
    drawNode(triggerAction, containerWidth / 2, TOP_PADDING)
  }

  return newNodes
}
